export const calCurrentTaxYear = () => {
  // TODO: Uncomment when backend is ready for dynamic year filing
  const date = new Date();
  const currentYear = date.getFullYear();
  return currentYear - 1;
  // return 2023; // TODO: Comment if previous block uncommented
};
